import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Toast } from "primereact/toast";

import { ObtenerCurrency } from "../../../API/Global/Currency/CurrencyRequest";
import Card from "../../../Components/Card/Card";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { Button } from "primereact/button";
import CurrencyCrudModal from "./CurrencyCRUD/CurrencyCrud";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";

// import './categoriaStyle.scss';

export const CurrencyScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [currency, setCurrency] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const c = await ObtenerCurrency();
    setCurrency(c);
    setLoading(false);
  };

  const colums = [
    {
      field: "IdCurrency",
      header: "ID Moneda",
      headerEn: "ID Currency",
      hidden: userAuth.IdRol === 1,
      width: 100,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Currency",
      header: "Nombre Moneda",
      headerEn: "Currency",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    { field: "CurrencySymbol", header: "Simbolo", headerEn: "Symbol" },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "IdCurrency",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: currency,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "moneda", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "moneda", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <CurrencyCrudModal
          toastRef={toast}
          monedasDialog={showDialog}
          moneda={selected}
          setMonedasDialog={setShowDialog}
          getMonedas={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default CurrencyScreen;
